module.exports = __webpack_public_path__ + "static/media/whiteChannels.d69942f0.svg";